<template>
  <div class="base-basic">
    <!-- 页面标题 -->
    <van-nav-bar title="首页" fixed />
    <!-- 占位元素，避免内容被固定的导航栏遮挡 -->
    <div class="nav-bar-placeholder"></div>

    <!-- 页面主体内容 -->
    <div class="body-content">
      <!-- Banner -->
      <van-swipe :autoplay="3000" indicator-color="white" class="custom-swipe">
        <van-swipe-item>
          <img src="/assets/home/轮播图3.png" alt="轮播图3" />
        </van-swipe-item>
        <van-swipe-item>
          <img src="/assets/home/轮播图2.png" alt="轮播图2" />
        </van-swipe-item>
        <van-swipe-item>
          <img src="/assets/home/轮播图1.png" alt="轮播图1" />
        </van-swipe-item>
      </van-swipe>

      <!-- Statistics Section -->
      <div class="stats-wrapper">
        <van-grid :column-num="4" class="stats-grid" :border="false">
          <van-grid-item class="stats-item" @click="goToPage('my-meetings', 1)">
            <template #icon>
              <div class="stats-number">{{ confirmedMeetingsCount }}</div>
            </template>
            <template #text>
              <div class="stats-label">待开展</div>
            </template>
          </van-grid-item>
          <van-grid-item class="stats-item" @click="goToPage('my-meetings', 2)">
            <template #icon>
              <div class="stats-number">{{ pendingMeetingsCount }}</div>
            </template>
            <template #text>
              <div class="stats-label">邀约中</div>
            </template>
          </van-grid-item>
          <van-grid-item class="stats-item" @click="goToPage('my-meetings', 3)">
            <template #icon>
              <div class="stats-number">{{ completedMeetingsCount }}</div>
            </template>
            <template #text>
              <div class="stats-label">已结束</div>
            </template>
          </van-grid-item>
          <van-grid-item class="stats-item" @click="goToPage('speakers-copy')">
            <template #icon>
              <div class="stats-number">{{ associatedSpeakersCount }}</div>
            </template>
            <template #text>
              <div class="stats-label">我的讲者</div>
            </template>
          </van-grid-item>
        </van-grid>
      </div>

      <!-- Action Cards -->
      <div class="cards-container">
        <Card icon="/assets/icons/conference-application-guidelines.png" text="会议申请须知" @click="showNotice"
          class="large-card large" :isImageIcon="true" />
        <Card icon="/assets/icons/my-speaker.png" text="讲者列表" @click="goToPage('speakers')" class="large-card large"
          :isImageIcon="true" />
        <Card icon="/assets/icons/meeting-application.png" text="会议申请" @click="goToPage('apply')"
          class="large-card large" :isImageIcon="true" />
        <Card icon="/assets/icons/meeting-confirm.png" text="会议确认" @click="goToPage('confirm')" class="large-card large"
          :isImageIcon="true" />
        <Card icon="/assets/icons/meeting-confirm.png" v-if="isAdmin" text="会议管理" @click="goToPage('meeting-mgmt')"
          class="large-card large" :isImageIcon="true" />
        <Card icon="/assets/icons/meeting-confirm.png" v-if="isSuperAdmin" text="系统管理" @click="goToPage('system')"
          class="large-card large" :isImageIcon="true" />
      </div>

      <!-- Notice Dialog -->
      <van-dialog v-model:show="showDialog" title="会议申请须知" confirm-button-text="我知道了" @confirm="closeDialog"
        @cancel="closeDialog" closeable overlay-click-close class="custom-dialog">
        <div class="notice-content">
          各位志愿者好！<br />
          为推动神经、代谢疾病领域诊疗水平提升，促进学术交流与知识共享，加强中青年医学人才队伍建设，现发起的"金牌代言人"项目已于2026年1月正式启动！<br /><br />

          会议开展规则：<br />
          1、每位志愿者将匹配绑定若干位医生讲者<br />
          2、每位讲者仅限参与<span class="highlight">5次活动/半年</span>（半年度动态更新）<br />
          3、由志愿者协助医生进行活动申请报名<br />
          4、为预留充足筹备时间，会议需至少提前7天发起申请<br /><br />

          会议申请流程：<br />
          1. 登录小程序<br />
          志愿者通过手机号验证码以及初始密码登录"会议申请助手"小程序，在"我的"中进行密码修改，之后可按自定义密码进入小程序。<br />
          志愿者进入后，将会自动绑定前期已给定的医生名单，可进行会议预约与确认。<br /><br />

          2. 申请会议<br />
          在首页页面，点击会议申请。<br />
          选择对应药品领域、细分领域、讲者，下一步<br />
          依次勾选会议日期、时间、会议形式、会议类型后，点击申请会议<br />
          <span class="highlight">每申请1次会议，将自动扣除对应医生会议次数，会议审批不通过/取消会自动释放次数。</span><br /><br />

          3.会议确认<br />
          由受邀方志愿者接收到短信以及小程序待确认会议显示<br />
          线下与讲者对接会议参会事宜<br />
          将邀约结果通过小程序点击参会/无法参会反馈发起方<br />
          无法参会的会议，可由申请方修改信息重新发起申请<br /><br />

          4. 会议结束<br />
          确认参会的会议，超过<span class="highlight">【会议结束时间】系统将自动默认完成会议。</span><br /><br />

          5. 变更与取消<br />
          <span class="highlight">在邀约中的会议，可以修改或取消。</span><br />
          <span class="highlight">已邀约成功/失败的会议，可变更或取消。</span><br />
          <span class="highlight">已结束的会议，特殊情况可取消。</span><br /><br />

          为维护平台秩序及医生个人隐私安全，各位志愿者请勿泄露医生及活动信息，如有发现将追究相应法律责任，谢谢支持！
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import Card from '../../components/Card.vue';
import { ref, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import { showFailToast } from 'vant';
import axios from '@/api/axios';
import { showSuccessToast } from 'vant';

export default {
  name: 'Home',
  components: {
    Card
  },
  setup() {
    const router = useRouter();
    const showDialog = ref(false);

    // 统计数据
    const confirmedMeetingsCount = ref(0);
    const pendingMeetingsCount = ref(0);
    const completedMeetingsCount = ref(0);
    const associatedSpeakersCount = ref(0);

    // 获取统计数据
    const fetchStatistics = async () => {
      try {
        // 从localStorage获取当前用户信息
        const currentUser = JSON.parse(localStorage.getItem('userInfo'));
        const liaisonOfficerId = currentUser ? currentUser.id : 1; // 默认值为1

        // 调用API获取统计数据
        const response = await axios.get(`/api/meetings/statistics/by-liaison-officer/${liaisonOfficerId}`);

        if (response.data.success) {
          const data = response.data.data;
          confirmedMeetingsCount.value = data.confirmed_meetings_count;
          pendingMeetingsCount.value = data.pending_meetings_count;
          completedMeetingsCount.value = data.completed_meetings_count;
          associatedSpeakersCount.value = data.associated_speakers_count;
        } else {
          showFailToast('获取统计数据失败');
        }
      } catch (error) {
        console.error('获取统计数据失败:', error);
        showFailToast('获取统计数据失败');
      }
    };


    // 组件挂载时获取数据
    onMounted(() => {
      fetchStatistics();
    });

    // 方法定义
    const showNotice = () => {
      showDialog.value = true;
    };

    const closeDialog = () => {
      showDialog.value = false;
    };

    const onClickExport = async () => {
      // 直接调用接口导出全量会议数据
      try {
        const response = await axios.post('api/meetings/export', {}, { responseType: 'blob' });

        // 创建下载链接并触发下载
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `meetings-export-${new Date().getTime()}.xlsx`);
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        showSuccessToast('导出成功');
      } catch (error) {
        console.error('导出会议数据失败:', error);
        showFailToast('导出会议数据失败');
      }
    }

    const goToPage = (page, status = null) => {
      switch (page) {
        case 'notice':
          showNotice();
          break;
        case 'speakers':
          router.push('/my-speakers'); // 跳转到我的讲者页面
          break;
        case 'speakers-copy':
          router.push('/my-speakers-cp'); // 跳转到我的讲者页面
          break;
        case 'my-meetings':
          // 处理status和index的映射关系，根据MeetingList.vue中的statusMap
          // 0:全部、1:待开展、2:邀约中、3:已结束
          if (status !== null) {
            router.push({ path: '/my-meetings', query: { status: status.toString() } });
          } else {
            router.push('/my-meetings');
          }
          break;
        case 'apply':
          router.push('/apply'); // 会议申请页面
          break;
        case 'confirm':
          router.push('/confirm'); // 会议确认页面路径，实际应根据需求调整
          break;
        case 'meeting-mgmt':
          router.push('/meeting-mgmt'); // 会议管理页面路径
          break;
        case 'system':
          router.push('/system'); // 系统管理页面路径
          break;
      }
    };

    const isAdmin = computed(() => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return userInfo.isAdmin;
    });

    const isSuperAdmin = computed(() => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return userInfo.isSuperAdmin;
    });

    // 返回数据和方法
    return {
      showDialog,
      confirmedMeetingsCount,
      pendingMeetingsCount,
      completedMeetingsCount,
      associatedSpeakersCount,
      showNotice,
      closeDialog,
      goToPage,
      onClickExport,
      isAdmin,
      isSuperAdmin
    };
  }
};
</script>

<style scoped>
/* 整体页面padding */
.base-basic {
  padding-bottom: 50px;
  /* 为底部导航留出空间 */
  min-height: calc(100vh - 50px);
  /* 减去底部导航的高度 */
}

/* 导航栏占位元素样式 */
.nav-bar-placeholder {
  height: 46px;
  /* Vant导航栏默认高度 */
}

/* 页面主体内容使用 App.vue 中定义的公共样式 */

/* 轮播图调整 */
.custom-swipe {
  margin-bottom: 15px;
}

.custom-swipe img {
  width: 100%;
  height: calc(100vw / 1.78);
  /* 保持宽高比6.56:3.69 (≈1.78) */
  object-fit: cover;
}

/* 轮播图样式 */
.custom-swipe {
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  /* 添加淡阴影效果 */
}

.custom-swipe img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

/* 统计卡片样式 */
.stats-grid {
  margin-bottom: 20px;
}

:deep(.van-grid) {
  background-color: transparent;
}

:deep(.van-grid-item) {
  background-color: transparent;
}

.stats-wrapper {
  background-color: #E5A170;
  /* 黄色主色调 */
  border-radius: 12px;
  overflow: hidden;
  height: calc((100vw / 1.78) * 0.37);
  /* 轮播图高度的37% */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

:deep(.van-grid-item__content) {
  background-color: transparent;
  border-radius: 0;
  margin: 0;
  padding: 15px 0;
  box-shadow: none;
  height: 100%;
}

.stats-number {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 5px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.stats-label {
  font-size: 14px;
  color: #fff;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* 功能卡片容器 */
.cards-container {
  margin-top: 10px;
  margin-bottom: 50px;
}

/* 会议申请须知大卡片 */
.large-card {
  margin-bottom: 15px;
  height: calc((100vw / 1.78) * 0.6);
  /* 轮播图高度的0.6倍 */
  padding: 30px 66px !important;
}

.notice-content {
  font-size: 12px;
  line-height: 1.5;
  max-height: 80vh;
  /* 设置最大高度 */
  overflow-y: auto;
  /* 如果内容超出高度则添加滚动条 */
  text-align: left;
  /* 左对齐文本 */
  padding: 10px;
  /* 添加四周10px的留白 */
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: #333;
}

/* 高亮文本样式 */
.highlight {
  color: red;
  font-weight: bold;
}

/* 对话框样式 */
:deep(.van-dialog) {
  transform: translateY(0) !important;
  top: 33px !important;
  /* 设置距离顶部的距离 */
  bottom: 33px !important;
  /* 设置距离顶部的距离 */
}

.body-content {
  margin-top: 40px;
  padding: 20px 16px;
}

</style>